module.exports = __webpack_public_path__ + "static/media/icon-plus.1b422169.svg";